import React from 'react';  

import "scss/components/ui/input/Button.scss";
import classnames from 'classnames';
import Anchor from 'js/components/ui/Anchor.js';

import {     Link  } from "react-router-dom";

export default function Button(props) {
    let editedProps = {...props} ;
    const availableColors = [  'green' , 'primary' ,  'primary-darker' , 'danger' ];
    const availableSizes = [ 'medium' , 'extralarge' , 'small' , 'large'];

     
    editedProps.className =  classnames( props.className?.split(/\s/g) ,  'DMFUI_Button' ,
        ( props.color &&  availableColors.includes(props.color) ? props.color :   'defaultColor' ) ,
        ( props.size &&  availableSizes.includes(props.size) ? props.size :  'medium' ) ,
        ( props.loading ? 'loading' : null ),
        ( props.fullwidth !== undefined ?  'fullwidth' : null ) ,
        ( props.uppercase ? 'uppercase' : null ) ,
        { 'selected' : props.selected } , 
        ( props.link ? 'link' : 'button') , 
        ( props.variant &&  props.variant.toLowerCase().trim() == 'outlined' ? 'Variant_outlined' : 'Variant_default' ) 
    );

    editedProps.loading = null;
    editedProps.color = null;
    editedProps.size = null;
    editedProps.fullwidth = null;
    editedProps.uppercase = null;

    let buttonCaption = ( props.caption ?? '');
    buttonCaption = ( props.children ?? '');
    if( props.loadingCaption && props.loading ){
        buttonCaption = props.loadingCaption ;
    }

    if( props.href ){
        editedProps.to = props.href;
    }

    if( props.href ){
        return <Link 
         {...editedProps}
                disabled={ ( props.disabled || props.loading )  ? true: false }
            >
                {   buttonCaption  }
            </Link>
    } else {
        return <button 
         {...editedProps}
                disabled={ ( props.disabled || props.loading )  ? true: false }
            >
                {   buttonCaption  }
            </button>
    }
    return ;
}

 